import script from "./RefundDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./RefundDetail.vue?vue&type=script&setup=true&lang=js"

import "./RefundDetail.vue?vue&type=style&index=0&id=fbbf207c&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbbf207c"]])

export default __exports__